var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
    "dismiss": `Hylk\xe4\xe4`
};


export {$7c28f5687f0779a9$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
